module.exports = __webpack_public_path__ + "img/semirigido_dx.ab6f5536.png";